module.exports = __webpack_public_path__ + "static/media/LYNX.67104817.png";